export default "__VITE_ASSET__BzEmpfBn__"